<template>
  <div class="bg bg-2">
    <div class="form">
      <!-- <div class="form-row">
        <div class="label">
          <img src="../../assets/images/System.png" alt="">
        </div>
        <div class="value">
          <select class="system-select input" name="" id=""></select>
        </div>
      </div> -->
      <div class="form-row">
        <div class="label">
          <img src="../../assets/images/Payment-Platform.png" alt="">
        </div>
        <div class="value">
          <!-- <select class="pay-select input" name="" id=""></select> -->
          <div class="pay-select input">
            <img class="pay-icon" src="../../assets/images/paypal.png" alt="">
            <span class="input-value">paypal</span>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="label">
          <img src="../../assets/images/Player-Information.png" alt="">
        </div>
        <div class="value">
          <span class="placeholder">ID</span>
          <input class="id-input input" type="tel" v-model="role_id">
        </div>
        <div class="info-btn" @click="onConfirmInfo()">Confirm</div>
      </div>
      <div class="items-row">
        <div class="label">
          <img src="../../assets/images/Select-Items.png" alt="">
        </div>
        <div class="items">
          <template v-for="(item, index) in itemUrls">
            <div class="item-box" :class="index === itemIndex ? 'item-box-pick' : ''" @click="onClickItem(index)">
              <img class="select" v-if="index === itemIndex" src="../../assets/images/select.png" alt="">
              <img class="item" :src="item" alt="">
            </div>
          </template>
        </div>
      </div>
      <div class="rule-row">
        <span class="title">How to use your vouchers:<br></span>
        <span class="content">
          1. Vouchers will be issued to your game upon purchasing. Please claim the vouchers in time.<br>
          2. Vouchers can be used to purchase in-game items including "Diamond", "Pack", "Monthly Card" and so on.<br>
          3. Each voucher can only be used once to purchase in-game items of the exact same price.<br>
          4. Purchasing vouchers does not grant you in-game VIP EXP. <br>
          &nbsp;&nbsp;&nbsp;Corresponding VIP EXP will only be obtained when you consume your vouchers to purchase in-game items.<br>
          5. If you haven't received the voucher you have purchased within 24 hours, please contact us via email at<br>                     
          &nbsp;&nbsp;&nbsp;cs_na@flame-games.com
        </span>
      </div>
    </div>
    <div class="btn-row">
      <img class="confirm-btn" @click="onConfirmPay" :class="hasConfirmInfo && !disableYes ? '' : 'disabled-btn'" src="../../assets/images/confirm-btn.png" alt="">
    </div>
    <div class="dialog" v-if="isShowConfirmInfo">
      <div class="content">
        <div class="row"><div class="label">System: </div><span>&nbsp;&nbsp;{{ roleInfo.os }}</span></div>
        <div class="row"><div class="label">Server: </div><span>&nbsp;&nbsp;{{ roleInfo.server_name }}</span></div>
        <div class="row"><div class="label">Name: </div><span>&nbsp;&nbsp;{{ roleInfo.role_name }}</span></div>
        <div class="row"><div class="label">Level: </div><span>&nbsp;&nbsp;{{ roleInfo.role_level }}</span></div>
      </div>
      <div class="btns">
        <div class="btn" :class="disableYes ? 'disabled-yes' : ''" @click="onYes">Yes</div>
        <div class="btn" @click="toggleConfirmInfo(false)">Cancel</div>        
      </div>
    </div>
    <Toast v-if="msg" :msg="msg" @close="() => this.$store.commit('setMsg', '')"></Toast>
  </div>
</template>

<script> 
  import { getItems, getUserInfo, pay } from '@/global/api/api.js'
  import { getTs, getSign, generateUUID, throttle } from '@/global/js/utils.js'
  import Toast from '@/components/Toast.vue'

  const itemUrls = [
    require('../../assets/images/0.99.png'),
    require('../../assets/images/2.99.png'),
    require('../../assets/images/4.99.png'),
    require('../../assets/images/9.99.png'),
    require('../../assets/images/14.99.png'),
    require('../../assets/images/19.99.png'),
    require('../../assets/images/29.99.png'),
    require('../../assets/images/49.99.png'),
    require('../../assets/images/99.99.png')
  ]
  const PayType = {
    PayPal: 'paypal'
  }
  const PayInfo = {
    return_url: 'https://ga.flame-games.com/#/home/pay/1',
    cancel_url: 'https://ga.flame-games.com/#/home/pay/0'
  }
  const NotFound = {
    server_name: 'Character Not Found',
    role_name: 'Character Not Found',
    role_level: 'Character Not Found',
    os: 'Character Not Found'
  }
  export default {
    data() {
      return {
        items: [],
        itemIndex: 0,
        itemUrls: itemUrls,
        isShowConfirmInfo: false,
        disableYes: false, // 禁用确认信息里的Yes按钮，当禁用时，角色信息为空
        hasConfirmInfo: false,

        gameInfo: {
            game_id: 2,
            game_channel_id: 5,
            ad_id: 745,
        },
        role_id: "",
        roleInfo: NotFound,
        pay_type: PayType.PayPal
      }
    },
    components: { Toast },
    computed: {
      msg() {
        console.log('this.$store.state.msg', this.$store.state.msg);
        return this.$store.state.msg
      }
    },
    methods: {
      onClickItem(index) {
        this.itemIndex = index
      },
      toggleConfirmInfo(val) {
        this.isShowConfirmInfo = val
      },
      onYes() {
        if (this.disableYes) {
          return
        }
        this.hasConfirmInfo = true
        this.toggleConfirmInfo(false)
      },
      async onConfirmInfo() {
        this.hasConfirmInfo = false
        this.disableYes = true
        const params = {
          ...this.gameInfo,
          role_id: this.role_id,
          trace_id: generateUUID(),
          ts: getTs(),        
        }
        const sign = getSign(params)
        params.sign = sign
        getUserInfo(params).then(res => {
          this.disableYes = false
          this.roleInfo = res.data
          this.toggleConfirmInfo(true)          
        }).catch(err => {
          this.roleInfo = NotFound
          this.toggleConfirmInfo(true)          
        })
      },
      async pay() {
        console.log(!this.hasConfirmInfo || this.disableYes);
        if (!this.hasConfirmInfo || this.disableYes) {
          return
        }
        const item = this.items[this.itemIndex]
        const { user_id, role_id, role_name, server_id } = this.roleInfo
        const params = {
          ...this.gameInfo,
          user_id,
          role_id,
          role_name,
          server_id,
          product_id: item.product_id,
          money: item.sell_price,
          pay_type: this.pay_type,
          pay_info: PayInfo,
          trace_id: generateUUID(),
          ts: getTs(),
        }
        const sign = getSign(params)
        params.sign = sign
        const res = await pay(params)
        if (res.ret === 0) {
          const url = res.data.approve_url
          window.location.href = url
        } else {
          this.$store.commit('setMsg', 'Server Error')
        }
      },
      onConfirmPay: throttle(function () {
        this.pay()
      }, 500)
    },
    async created() {
      const params = {
        ...this.gameInfo,
        trace_id: generateUUID(),
        ts: getTs(),        
      }
      const sign = getSign(params)
      params.sign = sign
      const res = await getItems(params)
      if (res.ret === 0) {
        this.items = res.data
      }
    },
  }
</script>

<style lang="less" scoped>
@import url('../../assets/css/pc.less');
</style>